// extracted by mini-css-extract-plugin
module.exports = {"home-page":"styles_home-page__2L36c","footer":"styles_footer__5jaI5"};